/**
 * Copyright (C) 2019 Impulsis <info@impulsis.com>. All rights reserved.
 *
 * All information herein, source code below as well as the Morpheus system itself and all related
 * software (“Items”) are proprietary to Impulsis. Impulsis is the sole copyright owner of the Items.
 * Any use, reproduction, or disclosure of the Items without the written permission of Impulsis
 * is prohibited.
 */

import { replaceSubdomain } from '@morpheus/utils/admin-vue/helpers/api-helper'
import axios from 'axios'
import { VersionCreateData, VersionShowData, VersionsListData, VersionUpdateData } from '../types'

const versionsBaseURL = replaceSubdomain(process.env.VUE_APP_API_SUBDOMAIN_VERSION)

export const versionsClient = axios.create({
  baseURL: versionsBaseURL
})

export const versionsApplicationList = ['Client', 'Launcher', 'AssetsBundle']
export const versionsPlatformList = ['Win64', 'Linux64']

export function fetchVersionsList (param: string): Promise<VersionsListData> {
  param = param || ''
  return new Promise((resolve, reject) => {
    versionsClient.get(`${param}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function fetchVersionById (id: string): Promise<VersionShowData> {
  return new Promise((resolve, reject) => {
    versionsClient.get(`${id}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function createVersion (version: VersionCreateData): Promise<VersionsListData> {
  return new Promise((resolve, reject) => {
    versionsClient.post('', version)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function updateVersion (version: VersionUpdateData, id: string): Promise<VersionShowData> {
  return new Promise((resolve, reject) => {
    versionsClient.put(`${id}`, version)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function deleteVersionById (id: string): Promise<VersionShowData> {
  return new Promise((resolve, reject) => {
    versionsClient.delete(`${id}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export default {
  versionsApplicationList,
  versionsPlatformList,
  fetchVersionsList,
  fetchVersionById,
  createVersion,
  updateVersion,
  deleteVersionById
}
